module.exports = __webpack_public_path__ + "assets/img/0402.1628623a.svg";